import { RootStateOrAny, useSelector } from 'react-redux'

type UsePortalTranslations = () => {
  portalTranslationData: Array<{ [key: string]: string }>
  getTranslation: GetTranslation
}

type GetTranslation = ({ portalTranslationId, langVersion }: { portalTranslationId: string, langVersion: string }) => string | undefined

/**
 * Hook to get portal translations and translation function to get translation by portal translation id and language version
 * @returns {
 * portalTranslationData: Array<{ [key: string]: string }>,
 * getTranslation: GetTranslation
 * }
 */
export const usePortalTranslations: UsePortalTranslations = () => {
  const portalTranslationData = useSelector((state: RootStateOrAny) => state.portalTranslationData)

  const getTranslation: GetTranslation =
    ({ portalTranslationId, langVersion }) => {
      if (!Array.isArray(portalTranslationData)) {
        return undefined
      }
      const sectionTitleTranslation = portalTranslationData?.find(
        (translation) => translation.id === portalTranslationId
      )
      return sectionTitleTranslation?.[langVersion]
    }

  return {
    portalTranslationData,
    getTranslation
  }
}
